<template id="app-menu">
  <div
  id="menunav"
  :class="[
       'overflow-hidden',
    'menu-nav-root',
    'p-1',
    'pl-2',
    { 
      'bck-c': isMenuVisible,          // normal blue when menu visible
      // 'menunav-collapsed': !isMenuVisible  // special BG only when right arrow is shown
    }
  ]"
  :style="{ width: menuNavWidth + 'px' }"
>
    <div  class="menu-content" :class="{ 'annotations-collapsed': annotationsCollapsed }">
      <div class="menu-scroll" :style="menuScrollStyle">
        <div class="menu-header">
          <div class="menu-search-wrapper">
            <input
              v-model="searchTerm"
              type="text"
              placeholder="Search..."
              class="form-control form-control-sm menu-search-input"
            />
            <button
              v-if="searchTerm"
              type="button"
              class="menu-search-clear"
              title="Clear"
              @click="clearSearch"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
<!--          <i
            :class="isMenuExpanded ? 'fas fa-compress' : 'fas fa-solid fa-expand'"
            class="menu-expand-icon w-10 h-10"
            @click="toggleMenuWidth"
          ></i>-->
        </div>
        <nav>
          <menu-item
            v-for="(menu, idx) in filteredSideMenu"
            :key="idx"
            :menu="menu"
            :search-term="searchTerm"
          ></menu-item>
        </nav>
      </div>

      <!--Annotation messages - header moves to bottom when collapsed -->
      <div class="annotations" :class="{ 'annotations-at-bottom': annotationsCollapsed }">
        <div class="card text-dark">
          <div class="card-header card-header-annotations" @click="annotationsCollapsed = !annotationsCollapsed">
            <div class="row">
              <span>Messages</span>
              <div>
                <span class="fa-stack fa-1x">
                  <i class="fas fa-envelope fa-stack-1x"></i>
                  <i class="fa fa-circle fa-xs fa-stack icon-alignment">
                    <span class="icon-alignment-round">{{ $store.state.annotationCount }}</span>
                  </i>
                </span>
              </div>
              <i :class="annotationsCollapsed ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" class="annotations-chevron"></i>
            </div>
          </div>
          <div v-show="!annotationsCollapsed">
            <div v-for="(item, idx) in $store.state.annotations.filter(r=>r.isBizAnnon===false)" v-bind:key="idx"
                 :class="{ 'highlight-row': idx < $store.state.annotationCount }">
                            <span class="">
                                <i class="fa fa-user pa mr-1"></i>
                              <span class="pa">{{ item.userName }}</span>
                            </span>
            <span class="">
                                <span class="pa">{{ item.createTimestamp }}</span></span><br>
            <span> <i class="far fa-hand-point-right">
              <span>{{ item.annotation }}</span></i>
            </span>
            <hr class="m-0">

          </div>
        </div>
      </div>
    </div>
    </div>

    <!-- Arrows always at right of menu -->
    <div class="menu-arrows">
      <!-- Menu is visible -->
      <template v-if="isMenuVisible">
        <!-- Default width: show left (hide menu) and right (expand) -->
        <template v-if="!isMenuExpanded">
          <div
            class="menu-arrow"
            @click="toggleMenu(false)"
            title="Hide menu"
          >
            <i class="fa fa-arrow-left"></i>
          </div>
          <div
            class="menu-arrow"
            @click="toggleMenuWidth"
            :title="isMenuExpanded ? 'Collapse width' : 'Expand width'"
          >
            <i class="fa fa-arrow-right"></i>
          </div>
        </template>
        <!-- Expanded width: show only left to collapse width -->
        <template v-else>
          <div
            class="menu-arrow"
            @click="toggleMenuWidth"
            title="Collapse width"
          >
            <i class="fa fa-arrow-left"></i>
          </div>
        </template>
      </template>

      <!-- Menu is hidden: show only right arrow to open -->
      <template v-else>
        <div
          class="menu-arrow-right-arrow"
          @click="toggleMenu(true)"
          title="Show menu"
        >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="menu-chevron-expand bi bi-chevron-compact-right"
          viewBox="0 0 16 16"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M6.776 1.553a.5.5 0 0 1 .671.223l3 6a.5.5 0 0 1 0 .448l-3 6a.5.5 0 1 1-.894-.448L9.44 8 6.553 2.224a.5.5 0 0 1 .223-.671"
          />
        </svg>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import MenuItem from '@/components/menu'
// import {bus} from '@/bus'

export default {
  name: 'AppMenu',
  components: {MenuItem},
  data: function () {
    return {
      level1Menu: [],
      level2Menu: [],
      topMenu: [],
      menuMaster: {},
      userInfo: {},
      user: "",
      sideMenu: [],
      level1MenuFlag: false,
      level2MenuFlag: false,
      routes: this.$router.options.routes,
      baseMenuWidth: 230,
      expandedMenuWidth: 230,
      isMenuExpanded: false,
      searchTerm: '',
      isMenuVisible: true,
      annotationsCollapsed: false
    }
  },
  mounted: function () {
    this.getMenuMaster()
  },
  updated: function () {
  },
  computed: {
    showBanner() {
      return this.$store.state.showBanner
    },
    isLoggedIn() {
      return this.$store.state.isLoggedIn
    },
    currentMenuWidth() {
      return this.isMenuExpanded ? this.expandedMenuWidth : this.baseMenuWidth
    },
    menuScrollStyle() {
      return {
        width: this.currentMenuWidth + 'px',
        height: this.annotationsCollapsed ? undefined : '65vh'
      }
    },
    menuNavWidth() {
      return this.isMenuVisible ? this.currentMenuWidth : 8
    },
    filteredSideMenu() {
      const term = (this.searchTerm || '').toLowerCase().trim()
      if (!term) {
        return this.sideMenu
      }

      const filterTree = (node) => {
        if (!node) return null
        const name = (node.menuName || '').toLowerCase()
        const selfMatch = name.includes(term)

        let filteredChildren = []
        if (Array.isArray(node.children) && node.children.length) {
          filteredChildren = node.children
            .map(filterTree)
            .filter(child => child !== null)
        }

        if (selfMatch || filteredChildren.length) {
          return {
            ...node,
            children: filteredChildren
          }
        }
        return null
      }

      return this.sideMenu
        .map(filterTree)
        .filter(menu => menu !== null)
    }
  },
  methods: {
    toggleMenuWidth() {
      this.isMenuExpanded = !this.isMenuExpanded
    },
    clearSearch() {
      this.searchTerm = ''
    },
    toggleBanner: function () {
      this.$store.commit('toggleBanner')
    },
    ifRoute: (what) => {
      return what === location.pathname
    },
    toggleMenu(forceVisible) {
      // Only handle local visibility for arrows so the right arrow remains visible
      if (typeof forceVisible === 'boolean') {
        this.isMenuVisible = forceVisible
      } else {
        this.isMenuVisible = !this.isMenuVisible
      }
      if (!this.isMenuVisible) {
        this.isMenuExpanded = false
      }
    },
    getMenuMaster: function () {
     console.log('app-menu', 'load state'); this.$store.dispatch("loadState").then((cfg) => {
          console.log("menuMasterData",cfg.menuTree)
        // this.menuMaster = cfg.menuMasterData
        this.menuMaster = cfg.menuTree
        this.topMenu = this.menuMaster.filter(m => m.parentMenuId === 'Parent')
        this.sideMenu = this.menuMaster.filter(m => m.parentMenuId === 'Root')
        this.computeGlobalExpandedWidth()
      })
    },
    computeGlobalExpandedWidth: function () {
      const allMenus = this.menuMaster || []
      let maxLen = 0

      const traverse = (nodes) => {
        if (!Array.isArray(nodes)) return
        nodes.forEach(n => {
          if (!n) return
          if (n.menuName) {
            maxLen = Math.max(maxLen, n.menuName.length)
          }
          if (Array.isArray(n.children) && n.children.length) {
            traverse(n.children)
          }
        })
      }

      traverse(allMenus)

      const base = this.baseMenuWidth
      const perChar = 6 // px per character for 14px font
      let targetPx = base + perChar * maxLen

      // Cap to 40vw if window is available
      if (typeof window !== 'undefined' && window.innerWidth) {
        const maxPx = window.innerWidth * 0.4
        targetPx = Math.min(targetPx, maxPx)
      }

      this.expandedMenuWidth = targetPx
    }
  }
}

</script>
<style scoped>
/* float:left must always apply so main-content-area stays beside the strip (same as when menu visible) */
.menu-nav-root {
  position: relative;
  float: left;
  flex-shrink: 0;
}

.menu-arrow-right-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #010408;
  background-color: rgba(168, 164, 164, 0.03);
  border-radius: 4px;
  width: 100%;
  padding: 0;
  line-height: 0;
  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.menu-arrow-right-arrow .menu-chevron-expand {
  width: 16px;
  height: 24px;
  display: block;
  flex-shrink: 0;
  margin: 0 auto;
}

.menu-arrow-right-arrow .menu-chevron-expand path {
  stroke: currentColor;
  stroke-width: 0.45;
  paint-order: stroke fill;
}

.menu-arrow-right-arrow:hover {
  background-color: #0b2745;
  color: #ffffff;
  box-shadow: 0 0 0 1px rgba(11, 39, 69, 0.25);
}

.menu-arrow-right-arrow:hover .menu-chevron-expand path {
  fill: currentColor;
}

.menu-arrow-right-arrow:focus-visible {
  outline: 2px solid #1b75ff;
  outline-offset: 2px;
}

.bck-c {
  background-color: #0b2745;
  color: white;
  font-family: "helvetica";
  font-weight: normal;
  transition: width 0.2s ease;
  max-width: 40vw;
}

.menunav-collapsed {
  /* no extra margin so arrow can stay centered vertically */
  background-color: transparent;
}


.menu-scroll {
  height: 65vh;
  overflow-y: auto;
  margin-left: -12px;
  padding-left: -10px;
  transition: width 0.2s ease, height 0.25s ease;
  max-width: 40vw;
}

.menu-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0px 6px 0px 4px;
}

.menu-search {
  flex: 1;
  margin-left: 10px;
}

.menu-search-wrapper {
  position: relative;
  flex: 1;
  min-width: 0;
  margin-left: 10px;
}

.menu-search-input {
  padding-right: 22px; /* space for clear button */
}

.menu-search-clear {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: #c0cad9;
  font-size: 12px;
  line-height: 1;
}

.menu-search-clear:hover {
  color: #ffffff;
}

.menu-expand-icon {
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
}

.menu-content {
  display: flex;
  flex-direction: column;
  height: 93vh;
  overflow: hidden;
}

.menu-content .menu-scroll {
  flex: 0 0 auto;
}

.menu-content.annotations-collapsed .menu-scroll {
  flex: 1 1 0;
  min-height: 0;
}

.menu-content.annotations-collapsed .annotations.annotations-at-bottom {
  margin-top: auto;
  flex-shrink: 0;
}

.annotations {
  text-align: left;
  color: darkgrey;
  font-size: 12px;
  margin-top: 5px;
  height: 28vh;
  overflow-y: scroll;
  transition: margin 0.25s ease;
  @media (max-width: 1300px) {
    height: 27vh;
  }
}

.annotations.annotations-at-bottom {
  height: auto;
  min-height: auto;
  overflow: visible;
}

/*Tree Structure*/



.icon-alignment {
  color: red;
  margin-bottom: 25px;
  margin-left: 24px;
  width: 20px;

}

.icon-alignment-round {
  font-size: 12px;
  margin-left: -9px;
  color: white;
  font-weight: bold;
  margin-top: -20px;
  vertical-align: top;
}

.top-menu-icon {
  margin-left: -14px;
  font-size: 11px;
  vertical-align: top;
}

.top-menu-icon-text {
  margin-left: 14px;
  margin-top: -29px;
}

.fa.custom-fa {
  -webkit-text-stroke-color: #D6D6D6;
  color: transparent;
}
.float-menu{
  position: fixed;
  z-index: 2;
}

.menu-arrows {
  position: absolute;
  z-index: 3;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.menu-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  width: 100%;
  padding: 4px 0;
  background: #0b2745;
  border-radius: 4px;
}



.menu-arrow-right {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  width: 100%;
  padding: 4px 0;
  background: #0b2745;
  border-radius: 4px;
}

.menu-arrow:hover {
  background: #184170;
}

@media (max-width: 768px) {
  .menu-arrow{
    display:block;
  }

}

.row{
  justify-content: space-between;
}
.card-header {
  padding: 5px 18px;
}

.card-header-annotations {
  cursor: pointer;
  user-select: none;
}

.card-header-annotations .row {
  justify-content: space-between;
  align-items: center;
  gap: 0;
}

.annotations-chevron {
  margin-left: auto;
  font-size: 1rem;
}

.highlight-row{
  font-weight: bold;
}
</style>